import { Button, ButtonProps } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurColor, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

import { linkUnderlineStyles } from '../../../PlanCard.styles';

export const SmallerButton = styled(Button).attrs<Partial<ButtonProps>>({ size: 'xs', variant: 'text' })`
    color: ${({ negative }) => (negative ? getPurpurColor('functionalWhite') : getPurpurColor('textDefault'))};
    font-weight: ${getPurpurTypography('weightNormal')};
    font-size: ${getPurpurTypography('scale75')};
    line-height: ${getPurpurTypography('lineHeightLoose')};
    display: flex;
    padding: 0;
    text-align: right;
    ${({ negative }) => linkUnderlineStyles(negative)};
`;
